export default __webpack_public_path__ + "static/media/social_single.15d1079f.svg";